import { WecomOuterContact, WecomInnerContact } from "../../types";
import EventBus from "../event-bus";
const getContactDetailHook = new EventBus<
  WecomOuterContact | WecomInnerContact
>("getContactDetailHook");

export default getContactDetailHook;
